import { useEffect } from "react";
import { Grid } from "../../../../../components";
import { useClientSort, usePagination } from "../../../../../hooks";
import { Schema } from "../../../@types/";

type Props = {
  data: Array<unknown> | undefined | null;
  schema: Schema<unknown>;
};

/**
 * Components shows data and uses client side sort and pagination
 * @constructor
 */
const DynamicAnalysisGrid = ({ data, schema }: Props) => {
  const {
    sort,
    onSortChange,
    data: sortedData
  } = useClientSort(data ?? [], { field: "default", direction: "asc" });

  const {
    currentPageData,
    updatePageData,
    data: paginatedData
  } = usePagination(sortedData || []);

  useEffect(() => {
    updatePageData({
      newPage: 1
    });
  }, [sortedData, updatePageData]);

  return (
    <Grid
      data={paginatedData}
      numPages={currentPageData.numPages || 0}
      page={currentPageData.page}
      pageSize={currentPageData.pageSize}
      schema={schema}
      showPageNumbers
      sort={sort}
      totalResults={currentPageData.totalResults}
      onPageChange={(newPage: number, newPageSize: number) =>
        updatePageData({ newPage, newPageSize })
      }
      onSortChange={onSortChange}
    />
  );
};

export default DynamicAnalysisGrid;
